var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { compact, filter } from 'lodash';
import { SlimSelect, useLang, useChat, useAuth, CellLabel } from '@shapeable/ui';
import { useGpt } from '../hooks/use-gpt';
import { classNames } from '@shapeable/utils';
var cls = classNames('prompt-template-form');
import { template } from 'lodash';
import { PersonalisedToggle } from '../elements/personalised-toggle';
import { PromptVariableTextarea } from './prompt-variable-text-area';
import { PromptVariableEntitySelect } from './prompt-variable-entity-select';
import { ChatAutoMessageMenu } from '../elements/chat-auto-message-menu';
import { ChatFormButton } from '../elements/chat-form-button';
import { PromptVariableSelect } from './prompt-variable-select';
// -------- Types -------->
export var PromptTemplateFormControls = {
  "textarea": PromptVariableTextarea,
  "select": PromptVariableSelect,
  "entity-select": PromptVariableEntitySelect,
  "entity-select-current-entity-type": PromptVariableEntitySelect,
  "entity-select-current-entity-selected": PromptVariableEntitySelect
};
export var PromptTemplateFormDefaultProps = {
  cancelButtonLabel: 'Cancel'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-self: flex-end;\n    width: 100%;\n    box-sizing: border-box;\n\n    .shp--entity-select__indicator-separator {\n      margin-top: 16px;\n      margin-bottom: 16px;\n    }\n\n    .shp--entity-select--is-disabled .shp--entity-select__control {\n      background-color: transparent;\n    }\n\n    .shp--entity-select__control {\n      padding-top: 0;\n      padding-bottom: 0;\n      min-height: 60px;\n    }\n\n    .shp--entity-select .shp--entity-bubble-image {\n      width: 36px;\n      height: 36px;\n    }\n\n    .shp--prompt-variable-select,\n    .shp--prompt-variable-textarea {\n      max-width: none;\n    }\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-self: flex-end;\n    width: 100%;\n    box-sizing: border-box;\n\n    .shp--entity-select__indicator-separator {\n      margin-top: 16px;\n      margin-bottom: 16px;\n    }\n\n    .shp--entity-select--is-disabled .shp--entity-select__control {\n      background-color: transparent;\n    }\n\n    .shp--entity-select__control {\n      padding-top: 0;\n      padding-bottom: 0;\n      min-height: 60px;\n    }\n\n    .shp--entity-select .shp--entity-bubble-image {\n      width: 36px;\n      height: 36px;\n    }\n\n    .shp--prompt-variable-select,\n    .shp--prompt-variable-textarea {\n      max-width: none;\n    }\n\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: ", ";\n    color: ", ";\n  "], ["\n    padding-left: ", ";\n    color: ", ";\n  "])), theme.UNIT(2), theme.COLOR('text-mid'))
});
var VariablesStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: ", ";\n    width: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: ", ";\n    width: 100%;\n  "])), theme.UNIT(3))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    gap: ", ";\n\n    @media (max-width: 655px) { \n      flex-direction: column;\n      align-items: flex-end;\n    }\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    gap: ", ";\n\n    @media (max-width: 655px) { \n      flex-direction: column;\n      align-items: flex-end;\n    }\n  "])), theme.UNIT(3))
});
var SubmitButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var PreferencesPanelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var PersonalisedToggleStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    // to align better with selects\n    margin-top: 1px;\n  "], ["\n    // to align better with selects\n    margin-top: 1px;\n  "])))
});
var LangSelectorStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 180px;\n    cursor: pointer;\n\n    .shp--slim-select__control {\n      cursor: pointer;\n      padding-right: 0;\n      min-height: 32px;\n      border: solid 1px none;\n      border-radius: 8px;\n      color: ", ";\n      background-color: transparent;\n\n      &:hover {\n        color: ", ";\n        border: solid 1px ", ";\n        .shp--slim-select__indicator {\n          border-top-color: ", "; \n        }\n      }\n    }\n\n    .shp--slim-select__control--is-focused {\n      border-color: ", ";\n      &:hover {\n        border-color: ", ";\n      }\n    }\n\n\n    .shp--slim-select__menu {\n      background-color: #EAEAEA;\n      color: ", ";\n    }\n\n    .shp--slim-select__indicator {\n      padding-left: 0px;\n      margin-right: 0;\n    }\n\n    .shp--slim-select__single-value {\n      margin-right: 0;\n    }\n\n    .shp--slim-select__menu-list {\n      padding-bottom: 0;\n    }\n\n    .shp--slim-select__option {\n      border-color: #666;\n\n    }\n\n    .shp--slim-select__option--is-focused {\n      background-color: ", ";\n      color: #FFF;\n    }\n\n    @media (min-width: 655px) { \n      .shp--slim-select__control { \n        padding-right: 2px;\n      }\n  \n      .shp--slim-select__indicator {\n        margin-right: 4px;\n      }\n    }\n  "], ["\n    width: 180px;\n    cursor: pointer;\n\n    .shp--slim-select__control {\n      cursor: pointer;\n      padding-right: 0;\n      min-height: 32px;\n      border: solid 1px none;\n      border-radius: 8px;\n      color: ", ";\n      background-color: transparent;\n\n      &:hover {\n        color: ", ";\n        border: solid 1px ", ";\n        .shp--slim-select__indicator {\n          border-top-color: ", "; \n        }\n      }\n    }\n\n    .shp--slim-select__control--is-focused {\n      border-color: ", ";\n      &:hover {\n        border-color: ", ";\n      }\n    }\n\n\n    .shp--slim-select__menu {\n      background-color: #EAEAEA;\n      color: ", ";\n    }\n\n    .shp--slim-select__indicator {\n      padding-left: 0px;\n      margin-right: 0;\n    }\n\n    .shp--slim-select__single-value {\n      margin-right: 0;\n    }\n\n    .shp--slim-select__menu-list {\n      padding-bottom: 0;\n    }\n\n    .shp--slim-select__option {\n      border-color: #666;\n\n    }\n\n    .shp--slim-select__option--is-focused {\n      background-color: ", ";\n      color: #FFF;\n    }\n\n    @media (min-width: 655px) { \n      .shp--slim-select__control { \n        padding-right: 2px;\n      }\n  \n      .shp--slim-select__indicator {\n        margin-right: 4px;\n      }\n    }\n  "])), theme.COLOR('dark'), theme.COLOR('primary'), theme.COLOR('line-subtle'), theme.COLOR('primary'), theme.COLOR('primary'), theme.COLOR('primary'), theme.COLOR('text'), theme.COLOR('primary'))
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    align-self: flex-end;\n    display: flex;\n    flex-direction: row;\n    gap: ", ";\n  "], ["\n    align-self: flex-end;\n    display: flex;\n    flex-direction: row;\n    gap: ", ";\n  "])), theme.UNIT(3))
});
var AutoMessageMenuStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    .shp--chat-auto-message-button {\n      border-radius: 8px;\n\n      &:hover {\n        border-color: ", ";\n        color: ", ";\n      }\n    }\n  "], ["\n    .shp--chat-auto-message-button {\n      border-radius: 8px;\n\n      &:hover {\n        border-color: ", ";\n        color: ", ";\n      }\n    }\n  "])), theme.COLOR('primary'), theme.COLOR('primary'))
});
// -------- Components -------->
var My = {
  Container: styled.form(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Variables: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), VariablesStyles),
  Controls: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  PreferencesPanel: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PreferencesPanelStyles),
  LangSelector: styled(SlimSelect)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LangSelectorStyles),
  // change to slim select
  PersonalisedToggle: styled(PersonalisedToggle)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), PersonalisedToggleStyles),
  Buttons: styled.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  SubmitButton: styled(ChatFormButton)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), SubmitButtonStyles),
  CancelButton: styled(ChatFormButton)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), SubmitButtonStyles),
  AutoMessageMenu: styled(ChatAutoMessageMenu)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), AutoMessageMenuStyles)
};
export var PromptTemplateForm = function (props) {
  var _a, _b;
  var className = props.className,
    children = props.children,
    showCard = props.showCard,
    entity = props.entity,
    cancelButtonLabel = props.cancelButtonLabel;
  var isAuthenticated = useAuth().isAuthenticated;
  var _c = useGpt({
      entity: entity
    }),
    patchVariables = _c.patchVariables,
    patchViewState = _c.patchViewState,
    activeLanguage = _c.activeLanguage,
    languages = _c.languages,
    usePersonalisation = _c.usePersonalisation,
    activeTemplate = _c.activeTemplate,
    submitForm = _c.submitForm,
    variableValues = _c.variableValues,
    messages = _c.messages,
    showAutoPrompts = _c.showAutoPrompts;
  var onAutoMessageClick = function (message) {
    submitForm({
      values: message.values,
      color: message.useColor && message.color
    });
  };
  var submitButtonOnClick = function () {
    submitForm();
  };
  var inputOnSubmit = function (value) {
    submitForm();
  };
  var inputOnChange = function (variable) {
    return function (value) {
      var _a;
      patchVariables((_a = {}, _a[variable.name] = value, _a));
    };
  };
  var chat = useChat();
  var t = useLang();
  var labelTemplate = template('Output: <%= label %>');
  var langOption = function (lang) {
    return {
      value: lang.name || lang.label,
      entity: lang,
      label: labelTemplate({
        label: lang.label || lang.name
      })
    };
  };
  var activeLanguages = ((_a = activeTemplate === null || activeTemplate === void 0 ? void 0 : activeTemplate.languages) === null || _a === void 0 ? void 0 : _a.length) ? activeTemplate === null || activeTemplate === void 0 ? void 0 : activeTemplate.languages : languages || [];
  var languageSelectOptions = activeLanguages.map(langOption) || [];
  var langSelectorOnChange = function (value) {
    patchViewState({
      language: value.entity
    });
  };
  var autoFocus = false;
  var filledValues = filter(activeTemplate.variables.map(function (variable) {
    return (variableValues === null || variableValues === void 0 ? void 0 : variableValues[variable.name]) || '';
  }));
  var canSubmit = filledValues.length === activeTemplate.variables.length;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, t("Input:")), React.createElement(My.Variables, null, activeTemplate.variables.map(function (variable) {
    var _a;
    var controlTypeField = entity ? 'controlTypeContextual' : 'controlType';
    var fallbackControlTypeField = entity ? 'controlType' : 'controlTypeContextual';
    var controlType = variable[controlTypeField] || variable[fallbackControlTypeField];
    var Component = PromptTemplateFormControls[(controlType === null || controlType === void 0 ? void 0 : controlType.slug) || 'textarea'];
    if (Component) {
      var extraProps = {};
      if ((controlType === null || controlType === void 0 ? void 0 : controlType.slug) === "entity-select-current-entity-selected") {
        extraProps.title = t("Note: this selection is taken from the current page and cannot be changed. Navigate to the AI section of another page to generate content for a different topic.");
        extraProps.disabled = true;
      } else if ((controlType === null || controlType === void 0 ? void 0 : controlType.slug) === "select") {
        extraProps.title = variable.label;
        extraProps.options = compact((((_a = variable.options) === null || _a === void 0 ? void 0 : _a.text) || '').split('\n')).map(function (option) {
          return {
            value: option,
            label: option
          };
        });
      } else {
        autoFocus = messages.length === 0;
      }
      return React.createElement(Component, __assign({}, extraProps, {
        // autoFocus={autoFocus}
        contextEntity: entity,
        value: variableValues === null || variableValues === void 0 ? void 0 : variableValues[variable.name],
        key: variable.name,
        entity: variable,
        onSubmit: inputOnSubmit,
        onChange: inputOnChange(variable)
      }));
    }
  })), showAutoPrompts && React.createElement(My.AutoMessageMenu, {
    title: chat.autoPromptsTitle,
    prompts: chat.autoPrompts,
    color: "text",
    onMessageClick: onAutoMessageClick
  }), React.createElement(My.Controls, null, languageSelectOptions.length > 1 && React.createElement(My.LangSelector, {
    onChange: langSelectorOnChange,
    isClearable: false,
    value: langOption(activeLanguage),
    classNamePrefix: "lang-select",
    options: languageSelectOptions
  }), React.createElement(My.Buttons, null, React.createElement(My.SubmitButton, {
    title: canSubmit ? undefined : t('Please fill in all fields'),
    disabled: !canSubmit,
    onClick: canSubmit ? submitButtonOnClick : null
  }, ((_b = activeTemplate.type) === null || _b === void 0 ? void 0 : _b.name) || activeTemplate.submitLabel || 'Ask'))));
};
PromptTemplateForm.defaultProps = PromptTemplateFormDefaultProps;
PromptTemplateForm.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;